// extracted by mini-css-extract-plugin
export default {"card":"mochi-card_card__CyYgX"};